import React from 'react'
import styles from './FiltersPopover.scss'
import {Popover} from 'common/styleguide/Popover'
import {RangeInput} from 'common/styleguide/RangeInput'
import {CTA} from 'common/styleguide/CTA'
import {SEARCH_MAX, LENGTH_MAX, ELEVATION_MAX} from 'lib/api/search'
import {formatRangeLabel} from 'features/search/utils'

export class FiltersPopover extends React.PureComponent {
  constructor (props) {
    super(props)
    const {query} = this.props

    this.state = query.toJS()
  }

  startLocationChanged = (location) => {
    const stateUpdate = {
      start_location: location
    }

    // If start_location is blank, also blank out start_distance
    const locationAndRange = (!location || location === '') ? Object.assign(stateUpdate, {start_distance: SEARCH_MAX}) : stateUpdate

    this.setState(locationAndRange)
  }

  applyFilters = () => {
    const {query, doSearch, onRequestClose} = this.props

    const newQuery = query.merge(this.state).merge({sort_by: ''}) // We always want to sort by relevance once they apply some filters.
    doSearch(newQuery)
    onRequestClose()
  }

  onStartDistanceChange = (value) => {
    this.setState({start_distance: value})
  }
  getStartDistanceLabel = () => {
    const {metricUnits} = this.props
    const unitLabel = metricUnits ? 'kilometers' : 'miles'

    return (
      <div className={styles.rangeLabel}>
        {this.state.start_distance === SEARCH_MAX && 'Anywhere'}
        {this.state.start_distance !== SEARCH_MAX && `${this.state.start_distance} ${unitLabel}`}
      </div>
    )
  }

  getLengthValue = () => {
    return {
      min: this.state.length_min,
      max: this.state.length_max
    }
  }
  onLengthChange = (value) => {
    this.setState({
      length_min: value.min,
      length_max: value.max
    })
  }
  getLengthLabel = () => {
    const {metricUnits} = this.props
    const unitLabel = metricUnits ? 'kilometers' : 'miles'

    return (
      <div className={styles.rangeLabel}>
        {formatRangeLabel(this.state.length_min, this.state.length_max, 0, LENGTH_MAX, 'length', unitLabel)}
      </div>
    )
  }

  getElevationValue = () => {
    return {
      min: this.state.elevation_min,
      max: this.state.elevation_max
    }
  }
  onElevationChange = (value) => {
    this.setState({
      elevation_min: value.min,
      elevation_max: value.max
    })
  }
  getElevationLabel = () => {
    const {metricUnits} = this.props
    const unitLabel = metricUnits ? 'meters' : 'feet'

    return (
      <div className={styles.rangeLabel}>
        {formatRangeLabel(this.state.elevation_min, this.state.elevation_max, 0, ELEVATION_MAX, 'elevation', unitLabel)}
      </div>
    )
  }

  render () {
    const {target, onRequestClose} = this.props

    return (
      <Popover noPadding
        placement='bottom'
        maxWidth='90vw'
        rootClose={false}
        onRequestClose={onRequestClose}
        target={target}>
        <form className={styles.FiltersPopover} onSubmit={this.applyFilters}>
          <div className={styles.filterForm}>
            <label htmlFor='start_location'>
              Show near
            </label>
            <input type='text' name='start_location' className={styles.showNear} value={this.state.start_location} onChange={(e) => this.startLocationChanged(e.target.value)} />
            <div className={styles.filterInput}>
              Search Range
              <RangeInput
                disabled={!this.state.start_location || this.state.start_location === ''}
                minValue={0}
                maxValue={SEARCH_MAX}
                value={this.state.start_distance}
                onChange={this.onStartDistanceChange} />
              {this.getStartDistanceLabel()}
            </div>
            <div className={styles.filterInput}>
              Length
              <RangeInput
                minValue={0}
                maxValue={LENGTH_MAX}
                value={this.getLengthValue()}
                step={10}
                onChange={this.onLengthChange} />
              {this.getLengthLabel()}
            </div>
            <div className={styles.filterInput}>
              Elevation
              <RangeInput
                minValue={0}
                maxValue={ELEVATION_MAX}
                value={this.getElevationValue()}
                step={100}
                onChange={this.onElevationChange} />
              {this.getElevationLabel()}
            </div>
          </div>
          <div className={styles.footer}>
            <CTA inline small link margins={false} onClick={onRequestClose}>Cancel</CTA>
            <CTA inline primary small margins={false} onClick={this.applyFilters}>Apply</CTA>
          </div>
        </form>
      </Popover>
    )
  }
}
